import cx from 'classnames'

import { Href } from 'components/navigation'


type LogoProps = {
  className?: string
}

const Logo: React.FC<LogoProps> = (props) => {
  const { className } = props

  return (
    <Href
      to="/"
      className={cx('flex items-center', className)}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="50"
        height="43"
        viewBox="0 0 50 43"
        version="1.1"
      >
        <path
          d="M 24.447 2.750 C 22.973 4.263, 19.308 10.892, 16.302 17.481 L 10.836 29.463 13.668 35.850 C 15.226 39.362, 16.915 42.296, 17.423 42.368 C 18.381 42.505, 36.954 3.461, 36.983 1.250 C 36.994 0.417, 35.355 0, 32.063 0 C 27.993 0, 26.655 0.483, 24.447 2.750 M -0.005 5.250 C -0.014 7.116, 8.341 25, 9.221 25 C 9.639 25, 11.327 22.030, 12.972 18.401 C 16.256 11.159, 16.076 9.778, 11.371 6.078 C 8.357 3.706, 0.004 3.099, -0.005 5.250 M 38.059 10.604 C 35.298 12.927, 28.004 26.545, 27.997 29.391 C 27.992 31.542, 33.336 43.055, 34.206 42.765 C 35.583 42.306, 50.159 10.066, 49.484 8.974 C 48.221 6.931, 41.241 7.926, 38.059 10.604"
          stroke="none"
          fill="#fcbc04"
          fill-rule="evenodd"
        />
      </svg>
    </Href>
  )
}

export default Logo
